var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56469 13.4058C5.56469 14.1868 4.37825 14.1868 4.37825 13.4058V4.05536L3.02266 5.45259C2.48043 6.01076 1.63143 5.18679 2.17452 4.62776L4.51689 2.21358C4.7743 1.92824 5.16984 1.92944 5.42587 2.21341L7.76859 4.62776C8.31168 5.18696 7.46268 6.01076 6.92045 5.45259L5.56469 4.05536V13.4058ZM7.86953 11.3728L10.2119 13.787C10.4611 14.0631 10.8472 14.0679 11.0928 13.8183L13.4636 11.3728C14.0067 10.8136 13.1577 9.9898 12.6155 10.548L11.2597 11.9452V2.59455C11.2597 1.81359 10.0733 1.81359 10.0733 2.59455V11.9452L8.71767 10.548C8.17526 9.98962 7.32626 10.8143 7.86953 11.3728Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/upDown.e15d09d09751e17b70bb672701c5b507.svg";
export { ForwardRef as ReactComponent };